$(document).ready(function () {
  if ((window.location.href == 'https://www.spydistillery.com/collections/products/' || window.location.href == 'https://www.spydistillery.com/collections/products') && $('.tag-filter').length) {
    $('.tag-filter').find('ul').find('li:first-child').addClass('active');
  }

  if ($('.template-page.dynamic').length) {
    const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      speed: 800,
      autoplay: {
        delay: 4000,
      },
    });
  }


  $('#age-enter').click(function() {
    console.log("Set cookie");
    setCookie('ageverification', 'ageverification', 1);
    $('.age-modal').removeClass('visible');
  });
  
  
  $('#age-exit').click(function() {
    window.location.replace("https://google.com");
  });  

  const ofAge = getCookie('ageverification');

  if (ofAge) {
    console.log("Is of age");
    console.log("Age verification cookie expires: ");
    console.log(ofAge);
    
  } else {
    console.log("Is not of age");
    $('.age-modal').addClass('visible');
  }

  // Cookie helper functions
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }



});